import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommunicationManagerService, Department, Position } from '@ops/shared-types';
@Injectable({
  providedIn: 'root',
})
export class DepartmentService {
  constructor(private cm: CommunicationManagerService) {}

  public getDepartmentsForTeam(projectId: any) {
    return this.cm.get(`department/all/team`, [
      { headerName: 'projectId', headerValue: projectId },
    ]);
  }
  public getDepartmentsForLogistics(projectId: any) {
    return this.cm.get(`department/all/logistic`, [
      { headerName: 'projectId', headerValue: projectId },
    ]);
  }

  public getAllDepartments(): Observable<Array<Department>> {
    return this.cm.get(`department/all`);
  }
}
